import React from 'react';

const Profile = ({ id, name, email, role }) => {
    return (
        <div className="content-wrapper">
            <div className="card ml-1 mr-1">
                <div className="card-header">
                    <h3 className="card-title">Profil</h3>
                </div>
                <div className="card-body">
                    <table className="table table-bordered" style={{ maxWidth: "600px" }}>
                        <tbody>
                        <tr>
                            <th style={{ width: "180px" }}>Ad</th>
                            <td>{name || '—'}</td>
                        </tr>
                        <tr>
                            <th>Email</th>
                            <td>{email || '—'}</td>
                        </tr>
                        <tr>
                            <th>Rol</th>
                            <td>
                                {role === 'ADMIN'
                                    ? <span className="badge badge-pill badge-primary">Admin</span>
                                    : <span className="badge badge-pill badge-secondary">{role || 'User'}</span>}
                            </td>
                        </tr>
                        <tr>
                            <th>Id</th>
                            <td>{id || '—'}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default Profile;
